/** Configuration for a single feature flag, including its enabled state and quota. */
export interface FeatureConfig {
  enabled: boolean
  quota: number | 'infinite'
}

/** Map of feature names to their configuration for a given organization. */
export type OrgFeatureMap = Record<string, FeatureConfig>

/** Exhaustive list of feature flags that can be configured per organization. */
export const AVAILABLE_FEATURES = ['eventplanner'] as const
